<template>
  <div
    class="setting_main_wrap"
    :style="Object.keys(question).length>0?sty:''"
  >
    <div
      v-if="Object.keys(option).length===0"
      class="question_setting"
    >
      <div class="q_title"> <span class="question_seq">Q{{ queIndex + 1 }}</span>. 题目设置 </div>
      <div class="block block_question">
        <div class="block_head">整题设置</div>
        <div class="block_mod">
          <div class="setting_item">
            <div class="hd">
              <span class="hd_text">此题必答</span>
              <el-switch
                v-if="question.setting"
                v-model="question.setting.required"
                style="float:right;"
              >
              </el-switch>
            </div>
          </div>
        </div>
      </div>
      <logic-setting></logic-setting>

      <div
        v-if="question.type!=='input'"
        class="block block_option"
      >
        <div class="block_head">选项设置</div>
        <div class="block_mod">
          <div class="setting_item">
            <div class="hd">
              <span class="hd_text">选项随机排列</span>
              <el-switch
                v-if="question.setting"
                v-model="question.setting.random"
                style="float:right;"
              >
              </el-switch>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="block fill_in_limit"
      >
        <div class="block_head">填写限制</div>
        <div class="block_mod">
          <div class="setting_item content_item">
            <div class="hd">内容限制
              <select
                v-model="question.setting.validate"
                class="select"
              >
                <option value="all">不限</option>
                <option value="number">数字</option>
                <option value="alphabet">字母</option>
                <option value="chinese">中文</option>
                <option value="email">Email</option>
                <option value="mobile">手机号码</option>
              </select>
            </div>
          </div>
          <div class="setting_item min_item">
            <div class="hd">最少填写 <div class="fr"> <input
                  v-model="question.setting.minlength"
                  class="q_input"
                  type="text"
                >
                <span>字</span>
              </div>
            </div>
          </div>
          <div class="setting_item max_item">
            <div class="hd">最多填写 <div class="fr"> <input
                  v-model="question.setting.maxlength"
                  class="q_input"
                  type="text"
                >
                <span>字</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="option_setting"
      style="opacity: 1;"
    >
      <div class="q_title"> <span class="question_seq">Q{{++queIndex}}</span>. 选项<span class="option_seq">{{++optIndex}}</span>
        的设置 </div>
      <div class="block block_option">
        <div class="block_mod">
          <div class="setting_item collapse_box expand">
            <div class="hd">在选项后增加填空框 <el-switch
                v-model="option.setting.show"
                style="float:right;margin-top:1.5px;"
              >
              </el-switch>
            </div>
            <div
              v-if="option.setting.show"
              class="collapse_item bd"
            >
              <div class="bd_item">内容限制 <select
                  v-model="option.setting.validate"
                  class="select_selection change_input_type"
                >
                  <option
                    value="all"
                    selected=""
                  >不限</option>
                  <option value="number">数字</option>
                  <option value="alphabet">字母</option>
                  <option value="chinese">中文</option>
                  <option value="email">Email</option>
                  <option value="mobile">手机号码</option>
                </select> </div>
              <div class="bd_item">该空是否必填 <el-switch
                  v-if="question.setting"
                  v-model="option.setting.required"
                  style="float:right;margin-top:1.5px;"
                >
                </el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LogicSetting from "./logic-setting";
export default {
  data() {
    return {
      a: "",
      sty: {
        opacity: 1,
        display: "block",
        right: 0,
        transition: "all .3s linear"
      }
    };
  },
  computed: {
    question: {
      get: function() {
        return this.$store.state.survey.activeQuestion;
      },
      set: function() {}
    },
    queIndex: {
      get: function() {
        return this.$store.state.survey.activeIndex;
      },
      set: function() {}
    },
    option: {
      get: function() {
        return this.$store.state.survey.activeOption;
      },
      set: function() {}
    },
    optIndex: {
      get: function() {
        return this.$store.state.survey.activeOptionIndex;
      },
      set: function() {}
    }
  },
  methods: {},
  components: {
    LogicSetting
  }
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
